<template>
	<div class="wrapper">
		<div class="col center login">
			<div class="row loginContainer">
					<div class="loginL">
						<div class="loginTitle white">
							{{appName}}
						</div>
						<div class="logoBig"></div>
						<div class="loginTitle white" style="font-size: 3rem; margin: 0;">EDUCACIÓN QUE TRANSFORMA</div>
					</div>
					<div class="loginR">
						<div class="col-10">
							<div class="loginTitle black">Bienvenido</div>
							<b-form-group label-size="1" :state="errors.first('username') ? false : true" :invalid-feedback="errors.first('username')" label="Usuario" label-for="username">
								<b-form-input @keyup.enter.native="validateBeforeSubmit" :state="errors.first('username') ? false : null" v-validate="'required'" v-model="username" id="username" name="username" type="text"></b-form-input>
							</b-form-group>
							<b-form-group :state="errors.first('password') ? false : true" :invalid-feedback="errors.first('password')" label="Contraseña" label-for="password">
								<b-form-input @keyup.enter.native="validateBeforeSubmit" :state="errors.first('password') ? false : null" v-validate="'required'" v-model="password" id="password" name="password" type="password"></b-form-input>
							</b-form-group>
							<b-alert variant="danger" show v-show="error">
								{{error}}
							</b-alert>
							<b-alert variant="danger" show v-show="errorMessage">
								{{errorMessage}}
							</b-alert>
							<div class="col center loginBtn">
								<b-button :disabled="submitted" variant="secondary lg" class="more" @click="validateBeforeSubmit">Ingresar</b-button>
							</div>
							<a :href="recoverPassUrl" target="_blank">Recuperar contraseña</a>
						</div>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
import Auth from '@/services/Auth';
import helpers from '@/helpers';

export default {
	props: ['error'],
	data: function () {
		return {
			username: '',
			password: '',
			errorMessage: '',
			submitted: false
		};
	},
	computed: {
		appName () {
			return this.$store.state.persistent.appName;
		},
		recoverPassUrl () {
			return `${process.env.LOGIN_URL}?username=${this.username}`;
		}
	},
	watch: {
		username () {
			this.errorMessage = null;
		},
		password () {
			this.errorMessage = null;
		}
	},
	methods: {
		validateBeforeSubmit: async function ()	{
			try {
				this.$store.dispatch('hideContent');
				this.errorMessage = null;
				let validationResult = await this.$validator.validateAll();
				if (validationResult) {
					this.submitted = true;
					await Auth.authenticate({
						username: this.username,
						password: this.password
					});
					this.$router.push(this.$router.currentRoute.query.redirect || '/coaching/school/summary');
				} else this.$store.dispatch('showContent');
			} catch (error) {
				this.$store.dispatch('showContent');
				if (error.response && error.response.data) console.log(error.response.data.message);
				if (error.response && error.response.data) {
					if (error.response.data.message == 'INVALID_SITUATION') this.errorMessage = 'La situación del usuario es inválida';
					else if (error.response.data.message == 'INVALID_STATUS') this.errorMessage = 'El estado del usuario es inválido';
					else if (error.response.data.message == 'INACTIVE_USER') this.errorMessage = 'El usuario está inactivo';
					else if (error.response.data.message == 'INVALID_USERNAME') this.errorMessage = 'El usuario es inválido o no existe';
					else if (error.response.data.message == 'NOT_FOUND') this.errorMessage = 'El usuario es inválido o no existe';
					else if (error.response.data.message == 'WRONG_PASSWORD') this.errorMessage = 'La contraseña es incorrecta';
					else this.errorMessage = error.response.data.message;
				} else this.errorMessage = error.toString();
			} finally {
				this.submitted = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";
.login {
	background-color: $blank;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-end;
	margin: 0;
	height: auto;
	min-height: 57rem;
	width: 100%;
	&Btn {
		margin: 4rem 0;
		padding: 0;
	}
	&Container {
		border: 0.1rem solid $liteGrey;
		box-shadow: 0 1px 1px #ddd;
		display: flex;
		height: 57rem;
		width: 106rem;
		position: relative;
	}
	&L {
		background-image: url('../../assets/logoBack.svg');
		background-size: 100%;
		background-position-x: 0;
		background-repeat: no-repeat;
		background-color: $silkBlue;
		background-position-y: center;
		border-top-left-radius: 0.2rem;
		border-bottom-left-radius: 0.2rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 50%;
	}
	&R {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 50%;
	}
	&Title {
		margin: 4rem 0;
		font-size: $xxxBigSize;
		color: $blank;
		font-weight: 700;
		text-align: center;
		width: auto;
		&.black {
			font-weight: 400;
			color: $semiBlack;
			padding: 0;
		}
	}
}

.logoBig {
	background-image: url('../../assets/logov2-header.svg');
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center bottom;
	margin: 4rem 0;
	width: 28.8rem;
	height: 33rem;
}

.btn.more.btn-secondary.lg {
	background-color: $accentBlue;
	border: none;
	font-size: $regularTitle;
	color: $blank;
	justify-self: center;
	height: 5rem;;
	width: 100%;
	&:hover {
		transition: background-color .3s ease-out;
		background-color: rgba($cat2, 0.9)
	}
}
.col-10 {
	padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/routes/Login.vue